import React from 'react';

const faqs = [
  {
    q: 'How fast can I see results?',
    a: 'Most merchants see their first extra sales within 72 hours of connecting their first POS.',
  },
  {
    q: 'Do I need technical skills?',
    a: 'Zero. If you can log into your Moniepoint or OPay dashboard, you can use Kolanut.ai.',
  },
  {
    q: 'Is my data safe?',
    a: 'Bank-level encryption. We never sell or share your transaction data. Ever.',
  },
  {
    q: 'What if I use multiple payment platforms?',
    a: 'We support all of them at once — Moniepoint + OPay + PalmPay + Nomba in one dashboard.',
  },
  {
    q: 'Can I cancel anytime?',
    a: 'Yes. No contracts. No hard feelings.',
  },
];

const NgFAQSection = () => {
  return (
    <section id="faq" className="py-12 sm:py-16 md:py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-black mb-3">
            Frequently asked questions.
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((item) => (
            <div
              key={item.q}
              className="rounded-2xl border border-gray-200 bg-white px-5 py-4"
            >
              <p className="text-sm sm:text-base font-semibold text-black mb-1">
                {item.q}
              </p>
              <p className="text-sm text-gray-700">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NgFAQSection;

